import { encodePlayer } from "@dust/world/internal";
import { useDustClient } from "../hooks/useDustClient";
import { useDozerQuery } from "./useDozerQuery";

export type PlayerInventorySlot = {
  slot: number;
  objectTypeId: number;
  amount: number;
};

export function usePlayerInventoryQuery(activeObjectTypeId = 0) {
  const { data: dustClient } = useDustClient();
  const userAddress = dustClient?.appContext.userAddress;
  const userEntityId = userAddress ? encodePlayer(userAddress) : undefined;
  const sqlQuery = `
SELECT "slot", "objectType", "amount" FROM "InventorySlot"
WHERE "owner" = '${userEntityId}';
  `;

  return useDozerQuery<PlayerInventorySlot[]>({
    sqlQuery,
    select: (data) => {
      return data[0].filter((item) => {
        const showAllObjects = activeObjectTypeId === 0;
        if (showAllObjects) {
          return true;
        }

        return item.objectTypeId === activeObjectTypeId;
      });
    },
    fields: {
      objectType: "objectTypeId",
    },
    format: {
      slot: (value) => Number(value),
      objectTypeId: (value) => Number(value),
      amount: (value) => Number(value),
    },
    enabled: !!userEntityId,
    refetchIntervalInBackground: true,
    refetchInterval: 5_000,
  });
}
